import React from 'react';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';
import {Link} from 'react-router-dom';
import { useParams, useNavigate } from "react-router-dom";
import { base_url_client } from '../../Constants/config';

const ClientSideBar = (props)=> {
  const navigate = useNavigate();
  const handleClick=()=>{
    navigate("../dashboard/ivc-add/initiateMode");
    props.handleAddCandidate(true);
  }
	return(
    <>
		<aside className="sidebar bg-white" style={{boxShadow: "0px 1px 2px #00000029"}}>
        <ul>
          <li className={
              props.activePage === "dashboard"
                ? "active"
                : ""
            }> 
          <a href={base_url_client + "/dashboard"} title="Dashboard">
            {/* <a href="#" data-toggle="tooltip" data-placement="bottom" title="Home"> */}
            <span className="icon p-0" style={{width: "25px"}}>
            <i data-feather="home"><FeatherIcon icon='home'/></i>
            </span>
            {/* </a> */}
            </a>
          </li>
          <li className={
              props.activePage === "candidateListing"
                ? "active"
                : ""
            }>
          <a href={base_url_client + "/listing-page"} title="Candidate Listing">
          
              <span className="icon check-square p-0" style={{ width: "25px" }}>
                <i><FeatherIcon icon="check-square" /></i>
              </span>

          </a>
        </li>
          <li className={
              props.activePage === "report"
                ? "active"
                : "" }>
          <a href={base_url_client + "/report"} title="Reports">
         
            <span className="icon p-0" style={{width: "25px"}}>
            <i data-feather="bar-chart-2"><FeatherIcon icon="bar-chart-2"/></i>
            </span>
           
            </a>
          </li>
         
          <li className={
              props.activePage === "myProfile"
                ? "active"
                : ""
            }>
          <a href={base_url_client + "/companyprofile"} title="Settings">
            <span className="icon p-0" style={{width: "25px"}}>
            <i data-feather="settings"><FeatherIcon icon='settings'/></i>
            </span>
            </a>
          </li>
          <li>
          <a href={base_url_client + "/dashboard/ivc-add/initiateMode"} title="Add candidate " class="mt-3">
            <span className="icon p-0" style={{width: "25px"}} title="Add Candidate">
            <i data-feather="user-plus" ><FeatherIcon icon='user-plus'/></i>
            </span>
            </a>
          </li>
        </ul>
      </aside>
      </>
	)
}

export default ClientSideBar;